import { useState, MouseEvent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import Info from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTableActionStyles } from "./styles";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import PriorityActiveToggle from "../../../components/active-toggle";
import { Priority } from "../../../../../@types/priority";

type Props = {
    priority: Priority;
};

export default function ListTableActions({ priority }: Props) {
    const { pathname } = useLocation();
    const { classes } = useTableActionStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} >
                <MoreVert />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/${priority.id}`}
                >
                    <Info htmlColor="#706E7A" />
                    Informações
                </MenuItem>
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/${priority.id}/editar`}
                >
                    <Edit htmlColor="#706E7A" />
                    Editar
                </MenuItem>
                <PriorityActiveToggle
                    priority={priority}
                    buttonTrigger={
                        <MenuItem
                            onClick={handleClose}
                            className={classes.menuItem}
                        >
                            <Delete htmlColor="#706E7A" />
                            Remover
                        </MenuItem>
                    }
                />
            </Menu>
        </>
    );
}